
<template>
  <div class="product-detail">
    <div class="detail-content">
      <div class="detail-swipe-wrap">
        <van-swipe class="my-swipe" indicator-color="#1baeae">
          <van-swipe-item
            v-for="(item, index) in detail.images"
            :key="index"
          >
            <img :src="prefix(item)" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="product-info">
        <div v-if="$i18n.locale == 'en'" class="product_103 le">
          PROD INFO：
        </div>
        <div v-else class="product_103 le">产品详情：</div>
        
        <table class="product_table"><tr>
        <td  v-if="$i18n.locale == 'en'" >NO：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_numbers }}</td>
        <td  v-if="$i18n.locale != 'en'" >商品货号：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_numbers }}</td>
        </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >NAME：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_enname }}</td>
        <td  v-if="$i18n.locale != 'en'" >商品品名：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_name }}</td>
        </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >COLOR：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_color_en }}</td>
        <td  v-if="$i18n.locale != 'en'" >颜色选择：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_color }}</td>
        </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >STYLE：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_style_en }}</td>
        <td  v-if="$i18n.locale != 'en'" >款式选择：</td><td v-if="$i18n.locale != 'en'">{{ detail.prodstyle }}</td>
       </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >MADE：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_made_en }}</td>
        <td  v-if="$i18n.locale != 'en'" >商品产地：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_made }}</td>
        </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >MATERIAL：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_material_en }}</td>
        <td  v-if="$i18n.locale != 'en'" >商品材质：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_material }}</td>
        </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >AGE：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_age_en }}</td>
        <td  v-if="$i18n.locale != 'en'" >适用年龄：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_age }}</td>
       </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >BOX SIZE：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_box_en }}</td>
        <td  v-if="$i18n.locale != 'en'" >外箱规格：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_box }}</td>
       </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >SIZE：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_inner_en }}</td>
        <td  v-if="$i18n.locale != 'en'" >产品规格：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_inner }}</td>
       </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >COUNT：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_box_num_en }}</td>
        <td  v-if="$i18n.locale != 'en'" >装箱数量：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_box_num }}</td>
        </tr><tr>
        <td  v-if="$i18n.locale == 'en'" >CONFIG：</td><td  v-if="$i18n.locale == 'en'" >{{ detail.prod_info_en }}</td>
        <td  v-if="$i18n.locale != 'en'" >产品配置：</td><td v-if="$i18n.locale != 'en'">{{ detail.prod_info }}</td>
        </tr></table>
      </div>
      <div class="product-intro">
    <div v-if="$i18n.locale == 'en'"   v-html="detail.prod_content_en">
    </div>
    <div  v-else  v-html="detail.prod_content">
    </div>
    </div>
    </div>
  </div>
</template>

<script>
import swiper from "../components/Swiper";
import fetch from "@/js/axios";
import { Toast } from "vant";
export default {
  name: "productdetail",
  data() {
    return {
      detail: {},
    };
  },
  components: {
    swiper,
  },
  async mounted() {
    const params = { id: this.$route.query.id }; // 参数
    fetch.post("/api/ApiProduct/Get", params).then(
      (res) => {
        this.detail = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less">
@import "../style/mixin";
.product-detail {
  .detail-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .fj();
    .wh(100%, 44px);
    line-height: 44px;
    padding: 0 10px;
    .boxSizing();
    color: #252525;
    background: #fff;
    border-bottom: 1px solid #dcdcdc;
    .product-name {
      font-size: 14px;
    }
  }
  .detail-content {
    .detail-swipe-wrap {
      .my-swipe .van-swipe-item {
        img {
          width: 100%;
          // height: 300px;
        }
      }
    }
    .product-info {
      padding: 0 0px;
      font-size: 16px;
      color: #333;
      line-height: 30px;
      span {
        padding-left: 20px;
        width: 100%;
      }
      .label{
        min-width: 100px;
      }
      .product_103 {
        width: 100%;
      color: @primary;
      text-align: center;
        background: #f9f9f9;
        font-size: 17px;
        padding-left: 10px;
      }
      .product-title {
        font-size: 18px;
        text-align: left;
        color: #333;
      }
      .product-desc {
        font-size: 14px;
        text-align: left;
        color: #999;
        padding: 5px 0;
      }
      .product-price {
        .fj();
        span:nth-child(1) {
          color: #f63515;
          font-size: 22px;
        }
        span:nth-child(2) {
          color: #999;
          font-size: 16px;
        }
      }
    }
    .product-intro {
      width: 100%;
      ul {
        .fj();
        width: 100%;
        margin: 10px 0;
        li {
          flex: 1;
          padding: 5px 0;
          text-align: center;
          font-size: 15px;
          border-right: 1px solid #999;
          box-sizing: border-box;
          &:last-child {
            border-right: none;
          }
        }
      }
      .product-content {
        padding: 0 20px;
        img {
          width: 100%;
        }
      }
    }
  }
  .van-goods-action-button--warning {
    background: linear-gradient(to right, #6bd8d8, @primary);
  }
  .van-goods-action-button--danger {
    background: linear-gradient(to right, #0dc3c3, #098888);
  }
}
.product_table
{
  border-top:1px solid rgb(224, 224, 224);
  border-left:1px solid rgb(224, 224, 224);
  border-collapse: collapse;
  width: 100%;
  tr{
  border-bottom:1px solid rgb(224, 224, 224);
  }
  td{
  border-right:1px solid rgb(224, 224, 224);
  padding-left: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/ProductDetail.vue